import { c as _c } from "react/compiler-runtime";
import type { AppearanceCopy, OnboardingSessionConfig } from '@onefootprint/request-types';
import type { BusinessBoKycData } from '@onefootprint/types';
import { Avatar } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { HeaderTitle } from '../layout';
type HeaderProps = {
  onboardingConfig?: OnboardingSessionConfig;
  businessBoKycData?: BusinessBoKycData;
  copies?: AppearanceCopy;
};
const Header = t0 => {
  const $ = _c(11);
  const {
    onboardingConfig,
    businessBoKycData,
    copies
  } = t0;
  const tenantName = onboardingConfig?.orgName || "";
  if (!onboardingConfig) {
    return null;
  }
  const t1 = onboardingConfig?.logoUrl;
  let t2;
  if ($[0] !== t1 || $[1] !== tenantName) {
    t2 = <Avatar name={tenantName} size="xlarge" src={t1} />;
    $[0] = t1;
    $[1] = tenantName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== businessBoKycData || $[4] !== copies || $[5] !== onboardingConfig || $[6] !== tenantName) {
    t3 = <div className="mt-3">{onboardingConfig.workflowRequest ? <WorkflowRequestHeader tenantName={tenantName} onboardingConfig={onboardingConfig} copies={copies} /> : businessBoKycData ? <BoKycHeader tenantName={tenantName} businessBoKycData={businessBoKycData} /> : <DefaultHeader tenantName={tenantName} onboardingConfig={onboardingConfig} copies={copies} />}</div>;
    $[3] = businessBoKycData;
    $[4] = copies;
    $[5] = onboardingConfig;
    $[6] = tenantName;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex flex-col items-center justify-center gap-4">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default Header;
const WorkflowRequestHeader = t0 => {
  const $ = _c(29);
  const {
    tenantName,
    onboardingConfig,
    copies
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.intro.header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  if (!onboardingConfig.workflowRequest) {
    return null;
  }
  const {
    context
  } = onboardingConfig.workflowRequest;
  if (context.kind === "beneficial_owners") {
    let t2;
    if ($[1] !== copies?.hostedHeaderTitle || $[2] !== t || $[3] !== tenantName) {
      t2 = copies?.hostedHeaderTitle || t(_temp, {
        tenantName
      });
      $[1] = copies?.hostedHeaderTitle;
      $[2] = t;
      $[3] = tenantName;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== copies?.hostedSubheaderTitle || $[6] !== t || $[7] !== tenantName) {
      t3 = copies?.hostedSubheaderTitle || t(_temp2, {
        tenantName
      });
      $[5] = copies?.hostedSubheaderTitle;
      $[6] = t;
      $[7] = tenantName;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
      t4 = <HeaderTitle title={t2} subtitle={t3} />;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  if (context.kind === "document") {
    const isBusiness = context.data.numBusinessDocs > 0;
    const titleKey = isBusiness ? "business-title" : "user-title";
    const count = context.data.numBusinessDocs + context.data.numUserDocs;
    let t2;
    if ($[12] !== copies || $[13] !== count || $[14] !== isBusiness || $[15] !== t || $[16] !== tenantName) {
      const getSubtitle = () => {
        if (copies?.hostedSubheaderTitle) {
          return copies.hostedSubheaderTitle;
        }
        if (isBusiness) {
          if (count === 1) {
            return t(_temp3, {
              tenantName
            });
          }
          return t(_temp4, {
            tenantName,
            count
          });
        }
        if (count === 1) {
          return t(_temp5, {
            tenantName
          });
        }
        return t(_temp6, {
          tenantName,
          count
        });
      };
      t2 = getSubtitle();
      $[12] = copies;
      $[13] = count;
      $[14] = isBusiness;
      $[15] = t;
      $[16] = tenantName;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    const subtitle = t2;
    let t3;
    if ($[18] !== copies?.hostedHeaderTitle || $[19] !== t || $[20] !== tenantName || $[21] !== titleKey) {
      t3 = copies?.hostedHeaderTitle || t($_5 => $_5[titleKey], {
        tenantName
      });
      $[18] = copies?.hostedHeaderTitle;
      $[19] = t;
      $[20] = tenantName;
      $[21] = titleKey;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    let t4;
    if ($[23] !== subtitle || $[24] !== t3) {
      t4 = <HeaderTitle title={t3} subtitle={subtitle} />;
      $[23] = subtitle;
      $[24] = t3;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    return t4;
  }
  let t2;
  if ($[26] !== onboardingConfig || $[27] !== tenantName) {
    t2 = <DefaultHeader tenantName={tenantName} onboardingConfig={onboardingConfig} />;
    $[26] = onboardingConfig;
    $[27] = tenantName;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  return t2;
};
const BoKycHeader = t0 => {
  const $ = _c(14);
  const {
    tenantName,
    businessBoKycData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.intro.header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const {
    name: businessName,
    inviter
  } = businessBoKycData;
  const t2 = inviter?.firstName;
  const t3 = inviter?.lastName;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = [t2, t3];
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const otherBoName = t4.join(" ");
  let t5;
  if ($[4] !== t || $[5] !== tenantName) {
    t5 = t(_temp7, {
      tenantName
    });
    $[4] = t;
    $[5] = tenantName;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== businessName || $[8] !== otherBoName || $[9] !== t) {
    t6 = t(_temp8, {
      otherBoName,
      businessName
    });
    $[7] = businessName;
    $[8] = otherBoName;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <HeaderTitle title={t5} subtitle={t6} />;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
const DefaultHeader = t0 => {
  const $ = _c(14);
  const {
    tenantName,
    onboardingConfig,
    copies
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.intro.header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const isKyb = Boolean(onboardingConfig.kind === "kyb");
  let t2;
  if ($[1] !== copies?.hostedHeaderTitle || $[2] !== isKyb || $[3] !== t || $[4] !== tenantName) {
    t2 = copies?.hostedHeaderTitle || (isKyb ? t(_temp9, {
      tenantName
    }) : t(_temp10, {
      tenantName
    }));
    $[1] = copies?.hostedHeaderTitle;
    $[2] = isKyb;
    $[3] = t;
    $[4] = tenantName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== copies?.hostedSubheaderTitle || $[7] !== isKyb || $[8] !== t || $[9] !== tenantName) {
    t3 = copies?.hostedSubheaderTitle || (isKyb ? t(_temp11, {
      tenantName
    }) : t(_temp12, {
      tenantName
    }));
    $[6] = copies?.hostedSubheaderTitle;
    $[7] = isKyb;
    $[8] = t;
    $[9] = tenantName;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <HeaderTitle title={t2} subtitle={t3} />;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp($) {
  return $["business-title"];
}
function _temp2($_0) {
  return $_0["recollect-bos-subtitle"];
}
function _temp3($_1) {
  return $_1["business-document-subtitle_one"];
}
function _temp4($_2) {
  return $_2["business-document-subtitle_other"];
}
function _temp5($_3) {
  return $_3["user-document-subtitle_one"];
}
function _temp6($_4) {
  return $_4["user-document-subtitle_other"];
}
function _temp7($) {
  return $["business-title"];
}
function _temp8($_0) {
  return $_0["bo-kyc-subtitle"];
}
function _temp9($) {
  return $["business-title"];
}
function _temp10($_0) {
  return $_0["user-title"];
}
function _temp11($_1) {
  return $_1["kyb-subtitle"];
}
function _temp12($_2) {
  return $_2["kyc-subtitle"];
}